import { getAllRecords, querySnapshotToArray, firestoreDocument } from '@/services/utils/Utils.js';

import { saveRecord } from '@/services/firebase/FirestoreService.js';

import firebase from 'firebase';

export const namespaced = true;

export const state = {
  workOrders: [],
  subscription: null,
};

export const getters = {
  workOrders: ({ workOrders }) => workOrders,
  workOrder: (state) => (id) => state.workOrders.find((workOrder) => workOrder.id === id),
};

export const mutations = {
  SET_WORK_ORDERS(state, workOrders) {
    state.workOrders = workOrders;
  },
  SET_SUBSCRIPTION(state, subscription) {
    state.subscription = subscription;
  },
};

export const actions = {
  fetchWorkOrders({ state, commit }) {
    if (state.subscription) {
      return;
    }

    const collection = firebase.firestore().collection('workOrders');
    const subscription = collection.onSnapshot((querySnapshot) => {
      commit('SET_WORK_ORDERS', querySnapshotToArray(querySnapshot));
    });

    commit('SET_SUBSCRIPTION', subscription);
  },
  saveWorkOrder(context, workOrderOptions) {
    return saveRecord(workOrderOptions).then((id) => id);
  },
  fetchWorkOrder({ getters }, id) {
    return new Promise((resolve, reject) => {
      if (getters.workOrder(id)) {
        resolve(getters.workOrder(id));
        return;
      }

      const workOrderDocument = firestoreDocument('workOrders')(id);
      workOrderDocument
        .get()
        .then((querySnapshot) => {
          resolve({
            ...querySnapshot.data(),
            id: querySnapshot.id,
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
